<template>
    <p>{{props.text}}</p>
</template>

<script>
export default {
    name: 'textComponent',
    props: ['props']
}
</script>

<style scoped>
p {
    padding: 20px;
    font-weight: bold;
    text-align: center;
}
</style>